/**
 *
 * @param elem
 * @returns {CanvasRenderingContext2D}
 */
export function get2dContext(elem) {
  return elem.current && elem.current.getContext('2d')
}

export function initialiseContext(context, dimensions, dpr) {
  scaleCanvas(context, dpr)
  setGlobals(context)
}

export function drawElements(context, dpr, dimensions, elements) {
  const {width, height} = dimensions
  const elementProps = {context, width, height}

  clearCanvas(context, dpr, width, height)
  elements.forEach(drawElement(elementProps))
}

function scaleCanvas(context, dpr) {
  context.setTransform(1, 0, 0, 1, 0, 0)
  context.scale(dpr, dpr)
}

function setGlobals(context) {
  context.strokeStyle = 'rgba(0,0,128, 1)'
  context.lineCap = 'round'
  context.shadowBlur = 3
  context.shadowColor = 'rgba(0,0,128, 1)'
}

function clearCanvas(context, dpr, width, height) {
  context.clearRect(0, 0, width * dpr, height * dpr)
}

function drawElement({width, height, context}) {
  return fn => fn({context, width, height})
}

